export default __webpack_public_path__ + "static/media/70.c768ab15.jpeg";